const signals = ['DATA', 'TRENDS', 'PEOPLE', 'ISSUES', 'INSIGHTS'];
const features = [
  { icon: 'ri-dashboard-3-line', label: 'Dashboards & MIS' },
  { icon: 'ri-bar-chart-box-line', label: 'Data analytics' },
  { icon: 'ri-stack-line', label: 'Technology platforms' },
  { icon: 'ri-smartphone-line', label: 'Digital applications' },
];

export default function TechnologyIntelligence() {
  return (
    <section id="technology" className="relative w-full py-20 md:py-28 overflow-hidden bg-primary-950">
      {/* Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20premium%20data%20visualization%20abstract%20background%2C%20deep%20emerald%20green%20and%20charcoal%20black%20with%20flowing%20warm%20amber%20gold%20glowing%20network%20lines%20and%20subtle%20floating%20data%20particles%2C%20soft%20bokeh%20light%20points%2C%20elegant%20institutional%20technology%20aesthetic%2C%20layered%20depth%2C%20no%20text%20no%20people%20no%20logos&width=1800&height=1000&seq=prabhaw-tech-2026&orientation=landscape"
          alt="Technology that turns intelligence into action"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/90 via-black/80 to-black/90"></div>
      </div>

      <div className="relative px-6 md:px-16 lg:px-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left — copy */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="text-[10px] tracking-[0.3em] uppercase text-accent-400 font-mono">05 / Technology + Intelligence</span>
            </div>
            <h2 data-reveal className="text-4xl md:text-5xl lg:text-[3.4rem] leading-[1.08] text-white tracking-tight font-semibold drop-shadow-lg">
              Technology that turns intelligence into action.
            </h2>
            <p data-reveal="fade" style={{ ['--reveal-delay' as never]: '120ms' }} className="mt-6 max-w-md text-[15px] md:text-base leading-[1.8] text-white/80 drop-shadow-sm">
              Prabhaw fuses field intelligence with modern platforms. Dashboards,
              MIS and digital systems turn what people tell us into what leaders can
              act on — in real time.
            </p>

            <div data-reveal-stagger className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {features.map((f) => (
                <div key={f.label} className="stagger-child flex items-center gap-3 rounded-md border border-white/15 bg-white/5 px-4 py-3">
                  <span className="w-9 h-9 rounded-md bg-accent-500/15 flex items-center justify-center text-accent-400">
                    <i className={`${f.icon} w-4 h-4 flex items-center justify-center`}></i>
                  </span>
                  <span className="text-[13px] text-white font-medium">{f.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right — engine diagram */}
          <div data-reveal="scale" className="relative">
            <div className="flex flex-col items-center gap-4">
              {/* Field data */}
              <div className="rounded-lg border border-accent-500/50 bg-accent-500/10 px-6 py-3 flex items-center gap-3">
                <i className="ri-map-pin-user-line w-5 h-5 flex items-center justify-center text-accent-400"></i>
                <span className="text-sm tracking-wide text-white font-mono uppercase">Field Data</span>
              </div>
              <i className="ri-arrow-down-line w-6 h-6 flex items-center justify-center text-accent-400"></i>

              {/* Engine */}
              <div className="w-full max-w-md rounded-2xl border border-accent-500/30 bg-white/5 backdrop-blur-md p-6 md:p-8">
                <div className="text-center mb-6">
                  <span className="font-deva text-2xl text-accent-400">प्रभाव</span>
                  <p className="text-[10px] tracking-[0.3em] uppercase text-white/60 font-mono mt-1">Prabhaw Intelligence Engine</p>
                </div>
                <div className="grid grid-cols-3 gap-2.5">
                  {signals.map((s, i) => (
                    <div
                      key={s}
                      className={`rounded-md py-3 text-center text-xs font-mono tracking-wider ${
                        i === 4
                          ? 'col-span-3 bg-accent-500 text-primary-950'
                          : 'bg-white/10 text-white border border-white/10'
                      }`}
                    >
                      {s}
                    </div>
                  ))}
                </div>
              </div>

              <i className="ri-arrow-down-line w-6 h-6 flex items-center justify-center text-accent-400"></i>

              {/* Decision support */}
              <div className="rounded-lg border border-white/20 bg-white/10 px-6 py-3 flex items-center gap-3">
                <i className="ri-government-line w-5 h-5 flex items-center justify-center text-accent-400"></i>
                <span className="text-sm tracking-wide text-white font-mono uppercase">Decision Support</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}